import {Box, Button, Container, Fade, Grid, Typography} from "@mui/material";
import useThemeStore from "../../store/theme";
import {useCookies} from "react-cookie";

const Intro = () => {

    const themeMode = useThemeStore(state => state.mode);

    return (
        <Container sx={{ mt: {xs: 5, lg: 2.5} }}>
            <Grid container spacing={2.5} alignItems="center">
                <Grid item xs={12} lg={7}>
                    <Typography variant="h1" fontSize={{ xs: "1.75rem", lg: "2.8rem" }} fontWeight={800}>
                        فضای ابری اشتراک فایل میلفا،</Typography>
                    <Typography mt={2} fontSize="1rem" textAlign="justify" sx={{ lineHeight: 1.75, maxWidth: {lg: '69%'} }}>کسی باید برای شما فایل مهمی بفرستد اما نمیدانید چطور؟ از سرویس درخواست فایل درایو میلفا استفاده کنید و در عرض چند ثانیه یک یا چند فایل را برای هر کسی بفرستید.</Typography>
                    <Button component="a" href="#quick-access" variant="contained" disableElevation sx={{ mt: 2, py: 2, px: {lg: 16}, width: {xs: "100%", lg: "auto"} }}>همین حالا شروع کنید</Button>
                </Grid>
                <Grid item xs={12} lg={5}>
                    <Box component="img" alt="Icon" src={themeMode === 'light' ? "/assets/image/icon/cloud-ill.svg" : "/assets/image/icon/cloud-ill2.svg"} width={1} sx={{ height: {xs: "80vw", md: "50vw", xl: "40vw"}, objectFit: "contain" }}/>
                </Grid>
            </Grid>
        </Container>
    )
}
export default Intro;
